import ApiService from "../../api.service";

// Actions
export const GET_MARKING_EXAM_LIST = "GET_MARKING_EXAM_LIST";
export const DELETE_MARKING_EXAM = "DELETE_MARKING_EXAM";
export const CREATE_MARKING_EXAM = "CREATE_MARKING_EXAM";
export const UPDATE_MARKING_EXAM = "UPDATE_MARKING_EXAM";
export const IMPORT_MARKING_QUESTION = "IMPORT_MARKING_QUESTION";
export const GET_LIST_STUDENT_ATTENDANCE = "academic/marking/attendance-list";
export const MAKING_EXAM_ATTENDANCE = "academic/marking/attendance"
export const GET_LIST_REASON_CHEAT = "academic/marking/cheating-reason/all"
export const GET_LIST_STUDENT_CHEAT = "academic/marking/cheating-reason-list"
export const STUDENT_VIOLATION_LIST = "academic/marking/student-regulation-violation-list"
export const STUDENT_VIOLATION = "academic/marking/student-regulation-violation"
export const GET_LIST_TASK_EXAM = "academic/academic-task"
export const STUDENT_CHEATING = "academic/marking/student-cheating"
export const STUDENT_CHEATING_OR_VIOLATION = "academic/marking/student-cheating-or-violation"
export const GET_STUDENT_CHEATING_LOG = "academic/marking/student-cheating-log"
export const GET_EXAM_WITH_ANSWER = "academic/exam-with-answers"
export const GET_EXAM_RESULT = "academic/submissions/result"
export const GET_SPEAKING_AI_RESULT = "GET_SPEAKING_AI_RESULT"
export const GET_RESULT_ENTRANCE_EXAM = "academic/submissions/result-entrance-exam"
export const MARK_CHEATING = "academic/submissions/score/zero"
export const MARK_EXAM_SUBMISSIONS = "academic/submissions/score"
export const GET_EXAM_STUDENT_INFO = "academic/submissions/result-after-import"
export const GET_ANSWER_DATA_STUDENT = "GET_ANSWER_DATA_STUDENT"
export const IMPORT_READING_AND_WRITING_EXAM_STUDENT = "academic/submissions/score/import"
export const EXPORT_STUDENT_INFO = "academic/marking/attendance-list/export"

const state = {};

const getters = {};

const mutations = {};

const actions = {
    [GET_MARKING_EXAM_LIST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query("academic/marking/exam", payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [GET_LIST_STUDENT_ATTENDANCE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_LIST_STUDENT_ATTENDANCE, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },


    [GET_LIST_TASK_EXAM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_LIST_TASK_EXAM, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [DELETE_MARKING_EXAM](context, id) {
        return new Promise(resolve => {
            ApiService.delete('academic/marking/exam', id).then(({data}) => {
                resolve(data);
            }).catch((response) => {
                console.log(response)
            });
        })
    },

    [CREATE_MARKING_EXAM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post("academic/marking/exam", payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [MAKING_EXAM_ATTENDANCE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(MAKING_EXAM_ATTENDANCE, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [UPDATE_MARKING_EXAM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`academic/marking/exam/${payload.id}`, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [IMPORT_MARKING_QUESTION](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post("academic/marking/question/import", payload)
                .then(({ data }) => resolve(data))
                .catch(({ response }) => reject(response));
        });
    },

    [GET_LIST_REASON_CHEAT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_LIST_REASON_CHEAT, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [GET_LIST_STUDENT_CHEAT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_LIST_STUDENT_CHEAT, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [STUDENT_VIOLATION_LIST](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(STUDENT_VIOLATION_LIST, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [STUDENT_VIOLATION](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(STUDENT_VIOLATION, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [STUDENT_CHEATING](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(STUDENT_CHEATING, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [STUDENT_CHEATING_OR_VIOLATION](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(STUDENT_CHEATING_OR_VIOLATION, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [GET_STUDENT_CHEATING_LOG](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_STUDENT_CHEATING_LOG, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [MARK_CHEATING](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(MARK_CHEATING, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [GET_EXAM_WITH_ANSWER](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_EXAM_WITH_ANSWER, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [GET_EXAM_RESULT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_EXAM_RESULT, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
  [GET_SPEAKING_AI_RESULT](context, academicTaskId) {
        return new Promise((resolve, reject) => {
            ApiService.query(`academic/academic-task/${academicTaskId}/speaking-ai-result`)
                          .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [GET_RESULT_ENTRANCE_EXAM](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_RESULT_ENTRANCE_EXAM, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [MARK_EXAM_SUBMISSIONS](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(MARK_EXAM_SUBMISSIONS, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [GET_EXAM_STUDENT_INFO](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(GET_EXAM_STUDENT_INFO, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },

    [IMPORT_READING_AND_WRITING_EXAM_STUDENT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(IMPORT_READING_AND_WRITING_EXAM_STUDENT, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [GET_ANSWER_DATA_STUDENT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query("academic/exam-with-answers-and-scores", payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
    [EXPORT_STUDENT_INFO](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.query(EXPORT_STUDENT_INFO, payload)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
